import misRutas from 'vue-routes-generator'
import GestionPermisosComponent from './App'

export default {
	install: Vue => {
		misRutas.route('/main').child('panel-control').child('permisos', {
			name: 'Gestión de permisos',
			component: GestionPermisosComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-permisos/vue/index.js